import { AbstractModel } from '@/lib/models/AbstractModel'

export class LiabilityDisclaimer extends AbstractModel {
  static classPath = 'liability'

  rallyRoundId = 0
  customerId = 0
}
